import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Observer } from 'rxjs';
import { delayWhen, flatMap, take } from 'rxjs/operators';
import { ISchool } from 'Src/ng2/shared/typings/interfaces/school.interface';
import { LoadTile, ResetTiles } from 'Src/ng2/store/actions/tile-actions/tile-actions';
import { getTilesList, getTilesLoadedStatus } from 'Src/ng2/store/selectors/tile-selectors/tile-selectors';
import { ITile } from '../interfaces/dashboard.interfaces';

@Injectable()
export class TileDataService {
  constructor(public store: Store<any>) {}

  getTileData$(schoolId: String): Observable<ITile[]> {
    const tilePayload = { schoolId };
    this.store.dispatch(new ResetTiles());
    return this.store.select(getTilesLoadedStatus).pipe(
      delayWhen((loaded: boolean) => this.loadTileData$(loaded, tilePayload)),
      flatMap(() => this.store.select(getTilesList)),
      take(1),
    );
  }

  loadTileData$(loaded: boolean, tilePayload): Observable<ITile[]> {
    return Observable.create((observer: Observer<any>) => {
      if (!loaded) {
        this.store.dispatch(new LoadTile(tilePayload));
      } else {
        observer.next('tile data loaded');
        observer.complete();
      }
    });
  }
}
